import { createContext, useMemo, useState, type ReactNode } from 'react';

type EmoviDocContextValue = {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  conversationId: number | null;
  setConversationId: (value: number | null) => void;
};

export const EmoviDocContext = createContext<EmoviDocContextValue | null>(null);

type EmoviDocProviderProps = {
  children: ReactNode;
};

export function EmoviDocProvider({ children }: EmoviDocProviderProps) {
  const [isOpen, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      isOpen,
      setOpen,
      conversationId,
      setConversationId,
    }),
    [conversationId, isOpen],
  );

  return <EmoviDocContext.Provider value={value}>{children}</EmoviDocContext.Provider>;
}
